<template>
  <div>
    <label :for="inputID" class="form-label">{{ label }}</label>
    <select
      class="form-select"
      @change="update"
      :required="required"
      :id="inputID"
      v-model="selectedValue"
      :name="inputID"
      :disabled="isDisabled"
    >
      <option disabled>{{ defaultValue }}</option>
      <option v-for="value in values" :key="value">
        {{ value }}
      </option>
    </select>
  </div>
</template>

<script setup lang="ts">
import { ref } from "vue";

const emit = defineEmits(["onUpdate"]);

const props = defineProps({
  values: {
    type: Array<string>,
  },
  defaultValue: {
    required: false,
    type: String || Number,
  },
  required: {
    required: false,
    type: Boolean,
  },
  label: {
    type: String,
  },
  inputID: {
    type: String,
  },
  isDisabled: {
    type: Boolean,
  },
});

const selectedValue = ref(props.defaultValue);

function update() {
  emit("onUpdate", props.inputID, selectedValue.value);
}

update(); // initial call to emit the defaultValue
</script>

<style scoped>
input {
  min-width: 300px;
}
</style>
